import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Root container for calculator
export const Container = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

// Preview area for large screens
export const Preview = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 300,
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.primary.main}30`,
  background: 'linear-gradient(160deg, rgba(34,211,238,0.08), rgba(12,18,32,0.85))',
  boxShadow: theme.shadows[10],
}));

// Mobile stats container
export const MobileStats = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(2),
  background: 'rgba(255,255,255,0.04)',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.primary.main}24`,
  boxShadow: theme.shadows[6],
}));

// Row for mobile recommended heights
export const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
}));

// Current setting box on mobile
export const CurrentBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1.25),
  background: 'rgba(34,211,238,0.1)',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.primary.main}35`,
}));

// Form container
export const Form = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

// Bold span for value highlights
export const BoldSpan = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  marginLeft: theme.spacing(1),
}));

// Mobile header for recommended heights with bottom margin
export const MobileHeader = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));
